module.exports = __webpack_public_path__ + "static/img/11.24e1c4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/11.jpg
// module id = qKGV
// module chunks = 1